import { SuggestEmailErrorResponse } from '@src/api/company/auth/companyUserApiClient';
import { SuggestFormValues } from '@src/features/company/company-user/CompanyUserEditForm';
import Modal from '@src/layouts/Modal';
import Button from '@src/ui/elements/button/Button';
import ErrorMessage from '@src/ui/elements/form/ErrorMessage';
import Input from '@src/ui/elements/form/Input';
import { firstError, hasError } from '@src/utils/errorMessageUtils';
import React from 'react';

interface SuggestEmailUpdateModalProps {
  values: SuggestFormValues;
  onChange: (value: Partial<SuggestFormValues>) => void;
  onSuggest: () => void;
  onClose: () => void;
  isOpen?: boolean;
  errors?: SuggestEmailErrorResponse;
}

const SuggestEmailUpdateModal: React.FC<SuggestEmailUpdateModalProps> = ({
  values,
  onChange,
  onSuggest,
  onClose,
  isOpen,
  errors,
}) => {
  return (
    <React.Fragment>
      {isOpen && (
        <div className='h-[120vh]'>
          <Modal width='500px'>
            <div className='flex grow flex-col gap-8 px-8 py-10'>
              <div className='border-b border-b-gray-350 pb-4'>
                <h2 className='text-lg font-semibold'>メールアドレス変更の提案を送る</h2>
              </div>

              <div className='flex flex-col gap-[6px]'>
                <div className='flex items-center gap-3'>
                  <label className=''>新しいメールアドレス</label>
                </div>
                <div className='flex gap-4'>
                  <div className='flex w-full flex-col gap-2'>
                    <Input
                      size='m'
                      type='text'
                      placeholder='sample@sample.co.jp'
                      value={values.suggestedEmail}
                      error={hasError(errors?.suggested_email)}
                      onChange={(e) => onChange({ suggestedEmail: e.target.value })}
                    />
                    <ErrorMessage>{firstError(errors?.suggested_email)}</ErrorMessage>
                  </div>
                </div>
              </div>
              <div className='mt-auto flex w-full justify-center gap-5'>
                <div className='w-[172px]'>
                  <Button
                    variant='secondary'
                    fullRounded
                    fullWidth
                    outline
                    onClick={onClose}
                  >
                    キャンセル
                  </Button>
                </div>
                <div className='w-[172px]'>
                  <Button
                    outline
                    fullRounded
                    fullWidth
                    onClick={onSuggest}
                  >
                    送信
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </React.Fragment>
  );
};

export default SuggestEmailUpdateModal;
